// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"CourseDetailPage_emptyWrapper__oGyY6","emptyText":"CourseDetailPage_emptyText__nsZpN"};